<template>
  <VCard class="detail-delivery-request-wrapper">
    <VBlock :padding="[20, 0, 20, 0]">
      <VA :onClick="onDeleteOrder">
        <VSpan text="주문내역 삭제" :color="TextColor.emergency" :size="16" :spacing="-0.38" />
      </VA>
    </VBlock>
  </VCard>
</template>

<script>
import VSpan, { TextWeight, TextType, TextColor } from '../../atoms/VSpan'
import VBullet from '../../atoms/VBullet'
import VA from '../../molecules/VA'
import VBlock, { Direction, Sort } from '../../molecules/VBlock'
import VCard from '../../molecules/VCard'

export default {
  name: 'OrderDetailDeleteRequest',
  components: { VSpan, VBlock, VBullet, VCard, VA },
  props: {
    onDeleteOrder: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      Direction,
      Sort,
      TextWeight,
      TextType,
      TextColor
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-delivery-request-wrapper {
  width: 100%;
  height: auto;
  // border-bottom: 1px solid $light-gray-5;
  margin-bottom: 25px;
}
</style>
